module.exports = __webpack_public_path__ + "media/scotty.e2dbbf0f.webm";